module.exports = __webpack_public_path__ + "img/icon_aplicaciones.eecaa812.svg";